<template>
  <div class="w-full">
    <label v-if="label" :for="textareaId" class="text-label block mb-1.5">
      {{ label }}
      <span v-if="required" class="text-danger ml-0.5" aria-hidden="true">*</span>
    </label>
    <p v-if="description" class="text-caption mb-2">{{ description }}</p>
    <textarea
      :id="textareaId"
      :value="modelValue"
      :rows="rows"
      :placeholder="placeholder"
      :disabled="disabled"
      :class="textareaClasses"
      v-bind="$attrs"
      @input="$emit('update:modelValue', $event.target.value)"
    />
    <p v-if="error" class="text-sm text-danger mt-1.5" role="alert">{{ error }}</p>
    <p v-else-if="hint" class="text-caption mt-1.5">{{ hint }}</p>
  </div>
</template>

<script>
let idCounter = 0

export default {
  name: 'BaseTextarea',
  inheritAttrs: false,
  props: {
    modelValue: { type: String, default: '' },
    label: String,
    description: String,
    hint: String,
    error: String,
    rows: { type: Number, default: 4 },
    placeholder: String,
    disabled: Boolean,
    required: Boolean,
  },
  emits: ['update:modelValue'],
  data() {
    return { textareaId: `textarea-${++idCounter}` }
  },
  computed: {
    textareaClasses() {
      return [
        'w-full rounded-lg border px-4 py-2.5 text-sm text-foreground placeholder:text-muted resize-y min-h-[100px] transition-colors duration-200 glass-input',
        'focus:border-primary focus:ring-2 focus:ring-primary/20 focus:outline-none',
        'disabled:opacity-50 disabled:cursor-not-allowed',
        this.error ? 'border-danger' : 'border-white/50 dark:border-white/10',
      ]
    },
  },
}
</script>
